import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./PlaceBid.module.sass";
import { ethers, utils, providers } from "ethers";
import TextInput from "../TextInput";
import {
  verifyBuyerAddress,
  createBuyerUser,
  PostBid,
} from "../../services/ApiServices";
import { Link } from "react-router-dom";
import Modal from "../Modal";
import TextArea from "../TextArea";
import Auction from "../../abi/AuctionMarket.json";
import { Row, Col } from "antd";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getUser } from "../../redux";

const Purchase = (props, { className }) => {
  const dispatch = useDispatch();

  const state = useSelector((state) => state);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);

  const [address, setAddress] = useState();

  const [email, setEmail] = useState("");

  const [userName, setUserName] = useState("");

  const [emailError, setEmailError] = useState("");

  const [userNameError, setUserNameError] = useState("");

  const [isCheckOut, setIsCheckOut] = useState(false);

  const [isCreate, setIsCreate] = useState(false);

  const [errormsg, setErrormsg] = useState();

  const [eth, setEth] = useState(1);

  const [txs, setTxs] = useState();

  const [value, setValue] = useState(0);

  const [isDelevered, setIsDeleverd] = useState(false);

  const [isSuccess, setIsSuccess] = useState(false);

  const [isSelectWallet, setIsSelectWallet] = useState(false);

  const [delevered, setDeleverd] = useState(false);

  const [txHash, setTxHash] = useState("");

  const [price, setPrice] = useState(parseFloat(props.currentBid));
  const [days, setDays] = useState();
  const [hours, setHours] = useState();
  const [minutes, setMinutes] = useState();
  const [seconds, setSeconds] = useState();
  const [currentBid, setCurrentBid] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const AuctionAddress = "0x14D7c2d970cDcD402c86349e3956B55EFa255CA4";
  const nftAddress = "0x459124c1320bb66a2d2e58e04e7d28c344631ded";
  const tokenId = 10001;
  const itemId = 1;
  // const openseaAddreess = `https://opensea.io/assets/${nftAddress}/${tokenId}`;
  const openseaAddreess = `https://opensea.io/collection/cyberdogz-v2`;
  useEffect(() => {
    // console.log("checking props...", props.item, eth);
  }, [props, eth]);

  const userDetails = async (uid) => {
    dispatch(getUser(uid));
  };

  const postBid = async () => {
    setErrormsg("");
    setIsSelectWallet(false);
    setIsLoading(true);
    let result;
    let body = {
      userId: address,
      assetId: props.item.id,
      tokenPrice: parseFloat(price),
      contractAddress: AuctionAddress,
    };
    let provider;
    let auction;
    let balance;
    try {
      // result = await PostBid(body);
      if (typeof window.ethereum == "undefined") {
        throw new Error("Metamask is not found.");
      } else {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        provider = new providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        const address = await signer.getAddress();
        let network = await provider.getNetwork();
        if (network.name !== "homestead") {
          setErrormsg("Please connect to Ethereum Mainnet");
          return setIsLoading(false);
           
        }
        balance = await provider.getBalance(address, "latest");

        let displayBalance = utils.formatUnits(
          utils.parseUnits(balance.toString(), "wei"),
          "ether"
        );

        console.log("User wallet balance", displayBalance);

        if (parseFloat(displayBalance) < price) {
          throw new Error("Insufficient Balance to complete the bid");
        }

        auction = new ethers.Contract(AuctionAddress, Auction.abi, signer);
      }

      let newBid;
      let bid_now;

      newBid = utils.formatUnits(
        utils.parseUnits(price.toString(), "ether"),
        "wei"
      );

      let estimatedGasLimit;
      let estimatedGasPrice;

      let nextBidValue = await auction.getActualValueForNextBid(itemId, newBid);

      console.log("nextBidValue:", nextBidValue.toString());

      try {
        estimatedGasLimit = await auction.estimateGas.placeBid(
          props.item.contractAddress,
          props.item.tokenId,
          props.item.itemId,
          newBid,
          { value: nextBidValue }
        );
      } catch (e) {
        setIsLoading(false);

        if (e.error.message) {
          setIsLoading(false);
          let message = e.error.message.split(":");
          return setErrormsg(
            message[0] === "execution reverted"
              ? message[2] === "auction period is over"
                ? "Auction ended."
                : message[2]
              : message
          );
        }
        console.log("Error on estimate gas limit: ", e.error.message);
        // setErrormsg("You do not have enough ETH to buy")
        return setIsLoading(false);
      }

      estimatedGasPrice = await provider.getGasPrice();

      console.log("gasPrice", estimatedGasPrice.toString());
      console.log("gasLimit:", estimatedGasLimit.toString());

      let overrides = {
        gasLimit: estimatedGasLimit,
        gasPrice: estimatedGasPrice,
        value: newBid,
      };

      try {
        bid_now = await auction.placeBid(props.item.contractAddress,props.item.tokenId,props.item.itemId, newBid, {
          value: nextBidValue,
        });

        setTxHash(bid_now.hash);
      } catch (error) {
        if (error.message) {
          setIsLoading(false);
          let message = error.message.split(":");
          return setErrormsg(
            message[0] === "MetaMask Tx Signature" ? message[1] : message
          );
        }
        console.log("Erron on bid now...", error);
        setIsLoading(false);
        return setErrormsg("Transaction failed");
      }

      let buyReceipt;

      try {
        buyReceipt = await bid_now.wait();
      } catch (error) {
        setIsLoading(false);
        if (error.message) {
          let message = error.message.split(":");

          return setErrormsg(
            message[0] === "MetaMask Tx Signature" ? message[1] : message
          );
        }
        console.log("Erron on wait ...", error);
        return setErrormsg("Transaction failed");
      }
      console.log("buyReceipt:", buyReceipt.transactionHash);
      let ethUsed = utils.formatUnits(
        utils.parseUnits(buyReceipt.gasUsed.toString(), "gwei"),
        "ether"
      );

      setIsLoading(false);

      console.log(`ethUsed: ${ethUsed} ETH`);

      if (buyReceipt.status) {
        setIsLoading(false);
        setIsSuccess(true);
        getCurrentBid();
        return console.log(
          `Buy Transaction receipt : https://etherscan.io/tx/${buyReceipt.transactionHash}`
        );
      }
    } catch (e) {
      setErrormsg(e.message) 
      setIsLoading(false);
      return console.log("error on bid", e.message);
    }
    try {
      if (result) {
        props.refresh();
        props.getAsset();
        props.onClose();
      }
    } catch (e) {
      setIsLoading(false);

      console.log("Error on postbid", e);
    }
  };
  useEffect(() => {
    // getCurrentBid()
    let address = localStorage.getItem("nftAddress");
    if (address) {
      setAddress(address);
    }
  }, []);

  useEffect(() => {
    console.log("checking props...", props);
    setCurrentBid(props.currentBid);
    wallet(true)
  }, []);
  useEffect(() => {
    setValue(state.Usd.USD);
  }, [state.Usd.USD]);
  const wallet = async (initiate) => {
    let meta;
    try {
      if (!window.ethereum)
        throw new Error("No crypto wallet found. Please install it.");

      meta = await window.ethereum.send("eth_requestAccounts");
    } catch (err) {
      return setErrormsg(err.message);
    }
    console.log(meta);
    setAddress(meta.result[0]);

    let user;
    try {
      user = await verifyBuyerAddress(meta.result[0]);
    } catch (error) {
      return setErrormsg(error.message);
    }

    if (user.success) {
      console.log(user);
      setIsSelectWallet(false);
      localStorage.setItem("userName", user.result[0].userName);
      localStorage.setItem("nftAddress", user.result[0].walletAddress);
      localStorage.setItem("uid", user.result[0].id);
      userDetails(user.result[0].id);
    } 
    // else {
    //   setIsCreate(true);
    // }

    if(!initiate) return postBid();
  };

  const handleUserName = (value) => {
    if (value.length < 3) {
      setUserNameError("Please enter username with atleast 3 characters");
      setUserName(value);
    } else {
      setUserNameError("");
      setUserName(value);
    }
  };
  const handleprice = (e) => {
    setPrice(e.target.value);
    if (e.target.value <= parseFloat(currentBid)) {
      setPrice(e.target.value);
      setErrormsg("Price should be greater than current bid");
    } else {
      setErrormsg("");
    }
  };

  const register = async () => {
    let result, body;

    body = {
      id: address,
      userName: userName,
      email: email,
    };

    try {
      result = await createBuyerUser(body);
    } catch (error) {
      setErrormsg(error.message);
    }

    if (result.success) {
      localStorage.setItem("userName", result.result.userName);
      localStorage.setItem("nftAddress", result.result.walletAddress);
      localStorage.setItem("uid", result.result.id);
      setIsCreate(false);
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      let value = 0;
      setAddress(result.result.walletAddress);
      try {
        ethers.utils.getAddress(address);
      } catch (error) {
        setErrormsg(error.message);
      }

      try {
        await provider.getBalance(address).then((balance) => {
          value = parseFloat(ethers.utils.formatEther(balance));
        });
        if (value < price) {
          setErrormsg("Insufficient Balance to complete the bid");
        } else {
          let tx = await signer.sendTransaction({
            to: address,
            value: ethers.utils.parseEther(price.toString()),
          });
          setTxs([tx]);
          postBid();
        }
      } catch (error) {
        setErrormsg(error.message);
      }
    } else {
      setErrormsg("Something went wrong please try again later.");
    }
  };

  const getCurrentBid = async () => {
    try {
      let provider;
      let auction;
      if (typeof window.ethereum == "undefined") {
        throw new Error("Please install metamask");
      } else {
        await window.ethereum.request({ method: 'eth_requestAccounts' })
        provider = new providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        auction = new ethers.Contract(AuctionAddress, Auction.abi, signer);
      }
      let data = await auction.getCurrentBid(1);

      console.log("checking auction item", data.toString());
      let current_bid = data.toString().split(",")[1];

      current_bid = utils.formatUnits(
        utils.parseUnits(current_bid.toString(), "wei"),
        "ether"
      );

      setCurrentBid(current_bid);
      console.log("Checking current bid...", current_bid);
    } catch (e) {
      return console.log(e);
    }
  };

  useEffect(() => {
    getTimeDifference();
    setInterval(() => getTimeDifference(), 1000);
  }, [props.item.createdAt]);

  const getTimeDifference = () => {
    const dateNow = moment.utc();
    const expiryDate = moment.utc(props.item.endDate);
    var duration = moment.duration(expiryDate.diff(dateNow));

    setDays(duration.days());
    setHours(duration.hours());
    setMinutes(duration.minutes());
    setSeconds(duration.seconds());
    return (
      <div>
        {days} {hours}:{minutes}:{seconds}
      </div>
    );
  };
  return (
    <>
      {isCreate ? (
        <div className={styles.modal}>
          <h3 className={styles.head}>Tell Us About Yourself</h3>
          <div className={styles.register}>
            <TextInput
              className={styles.field}
              label="User Name"
              name="userName"
              type="text"
              onChange={(e) => handleUserName(e.target.value)}
              placeholder="Enter name"
            />
          </div>

          <div className={styles.btns}>
            <button
              className={cn("button", styles.button)}
              onClick={() => register()}
            >
              Save
            </button>
          </div>
        </div>
      ) : isCheckOut ? (
        <div className={cn(className, styles.connect)}>
          {/* <h4>Item</h4> */}
          <h3 className={styles.title}>{props.item.title}</h3>
          <div className={styles.item}>
            {/* <img
              src={
                props.item.attachments.length > 0 &&
                props.item.attachments.filter(
                  (item) => item.fileType === "image"
                ).length > 0
                  ? props.item.attachments.filter(
                      (item) => item.fileType === "image"
                    )[0].url
                  : props.item.title[0]
              }
              className={styles.image}
            /> */}
            {props.item.attachments[0].fileType == "IMAGE" ? (
              <img
                src={props.item.attachments[0].url}
                alt="Card"
                className={styles.image}
              />
            ) : (
               <video
                          autoPlay={deviceWidth > 1005}
                          muted
                          loop={deviceWidth > 1005}
                          src={props.item.attachments[0].url}
                          type="video/mp4"
                          controls
                          controlsList="nodownload"
                          poster={props.item.attachments[1].url}
                        />
            )}
            <div>
              <div className={styles.creator}>
                <div>
                  <Link to={"/profile/" + props.item.userId.id}>
                    <div className={styles.avatar}>
                      <img src={props.item.userId.imageUrl} alt="Avatar" />
                    </div>
                  </Link>
                </div>
                <div className={styles.description}>
                  <div className={styles.category}>Created by</div>
                  <div className={styles.text}>
                    {props.item.userId.userName}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.info}>
            <div>
              <div>
                <label>Current Bid</label>
                <div>{props.item.tokenPrice} ETH</div>
              </div>

              <div>
                <TextInput
                  className={styles.field}
                  label="Price"
                  name="Item"
                  type="number"
                  placeholder="Enter Price in ETH"
                  onChange={handleprice}
                  value={price}
                  min="0"
                />
              </div>
            </div>

            <div>
              <div>You will pay</div>
              <div>1,500 ETH</div>
              <label>1,500.00</label>
            </div>
          </div>
          <div className={styles.btns}>
            <button
              className={cn("button-stroke", styles.button)}
              onClick={() => {
                props.onClose();
              }}
            >
              <button
                className={cn("button", styles.button)}
                onClick={() => {
                  if (address) postBid();
                  else setIsSelectWallet(true);
                  // props.onClose()
                }}
              >
                Proceed
              </button>
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className={cn(className, styles.connect)}>
          {/* <h4>Item</h4> */}
          <h3 className={styles.title}>{props.item.name}</h3>

          <div className={styles.item}>
            {/* <img
              src={
                props.item.attachments.length > 0 &&
                props.item.attachments[0].fileType === "image"
                  ? props.item.attachments[0].url
                  : props.item.title[0]
              }
              className={styles.image}
            /> */}
            {props.item.attachments[0].fileType == "IMAGE" ? (
              <img
                src={props.item.attachments[0].url}
                alt="Card"
                className={styles.image}
              />
            ) : (
              <video
                          autoPlay={deviceWidth > 1005}
                          muted
                          loop={deviceWidth > 1005}
                          src={props.item.attachments[0].url}
                          type="video/mp4"
                          controls
                          controlsList="nodownload"
                          poster={props.item.attachments[1].url}
                          className={styles.image}
                        />
            )}
            <div className={styles.text}>
              <div className={styles.creator}>
                {/* <div>
                  <Link to={"/profile/" + props.item.userId.id}>
                    <div className={styles.avatar}>
                      <img src={props.item.userId.imageUrl} alt="Avatar" />
                    </div>
                  </Link>
                </div>
                <div className={styles.description}>
                  
                </div> */}
                <div className={styles.info}>
                  <div className={styles.row}>
                    <label className={styles.heading}>Current Bid</label>
                    <span className={styles.price}>{props.item.tokenPrice} ETH</span>
                    <span className={styles.note}>
                      {(parseFloat(value) * parseFloat(props.item.tokenPrice)).toFixed(2)}{" "}
                      USD
                    </span>
                  </div>
                  <div className={styles.row}>
                    <label className={styles.heading}>Auction Ends</label>
                    <span className={styles.price}>
                      {days}d {hours}h {minutes}m {seconds}s
                    </span>
                  </div>
                  <div>
                    <TextInput
                      className={styles.field}
                      label="Price"
                      name="Item"
                      type="number"
                      placeholder="Enter Price in ETH"
                      onChange={handleprice}
                      value={price}
                      min="0"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {errormsg && <div className={styles.alert}>{errormsg}</div>}
          {isSuccess && (
            <div className={styles.success}>
              {" "}
              <div>Your bid placed successfully.</div>
              <div>
                <a href={openseaAddreess} target="_blank">
                  {" "}
                  click here to view on opensea market{" "}
                </a>
              </div>{" "}
            </div>
          )}

          <div className={styles.btns}>
            <button
              className={cn("button", styles.button)}
              style={
                isLoading
                  ? { justifyContent: "space-between" }
                  : { justifyContent: "center" }
              }
              disabled={price == 0}
              onClick={() => {
                if (address) postBid();
                else setIsSelectWallet(true);
                // setIsDeleverd(true);
                // props.onClose()
              }}
            >
              {isLoading ? "PROCESSING" : "BID NOW"}
              {isLoading && (
                <Spinner
                  animation="border"
                  variant="dark"
                  style={{ padding: "3%" }}
                  size="md"
                />
              )}
            </button>
            {txHash && (
              <div className={styles.success}>
                Transaction submitted.
                <a href={"https://etherscan.io/tx/" + txHash} target="_blank">
                  {" "}
                  &nbsp; View in explorer
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      <Modal visible={isSelectWallet} onClose={() => setIsSelectWallet(false)}>
        <div className={styles.modal}>
          <div className={cn("h4")}>Connect Wallet</div>
          <br />
          <div>
            Please connect your wallet to continue.
            <br /> The system supports the following wallets
            <br />
            <br />
          </div>
          <div
            className={styles.wallet}
            onClick={() => {
              wallet();
            }}
          >
            <img
              className={styles.metamask}
              src="data:image/svg+xml;base64,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"
            />
            MetaMask
            <img
              className={styles.iconimg}
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjAyMTUgOC42NDVMMTUuMzY0OCAxNEwxMC4wMjE1IDE5LjM1NUwxMS42NjY1IDIxTDE4LjY2NjUgMTRMMTEuNjY2NSA3TDEwLjAyMTUgOC42NDVaIiBmaWxsPSIjNzc3RTkwIi8+Cjwvc3ZnPgo="
            />
          </div>
        </div>
      </Modal>
      <Modal visible={isDelevered} onClose={() => setIsDeleverd(false)}>
        <div>
          <div className={styles.delevery}>
            <img
              src="https://cdn.dribbble.com/users/379798/screenshots/3244368/scooter-running.gif"
              height="70px"
            />
            <div className={cn("h4")} style={{ marginLeft: "8px" }}>
              Do you want to ge
            </div>
          </div>
          <br />
          <div className={styles.btns}>
            <button
              className={cn("button", styles.button, styles.leftbtn)}
              onClick={() => {
                // if (address) purchase();
                // else setIsSelectWallet(true);
                // setDeleverd(true)
              }}
            >
              Continue
            </button>
            <button
              className={cn("button-stroke", styles.button, styles.rightbtn)}
              onClick={() => {
                setIsDeleverd(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={delevered}
        onClose={() => setDeleverd(false)}
        outerClassName={styles.deleveryModal}
      >
        <div>
          <center className={cn("h4")}>Delivery address</center>
          <br />
          <Row>
            <Col span={11}>
              <TextInput
                className={styles.field}
                label="Name"
                name="name"
                // value={title}
                type="text"
                // onChange={(e) => {
                //   titleFunction(e);
                // }}
                placeholder="Name"
                required
              />
              <TextArea
                className={styles.field}
                label="Address"
                name="address"
                // value={description}
                // onChange={(e) => {
                //   descriptionFunction(e);
                // }}
                type="text"
                placeholder="2/8, adayar"
                required
              />
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <TextInput
                className={styles.field}
                label="City"
                name="city"
                // value={title}
                type="text"
                // onChange={(e) => {
                //   titleFunction(e);
                // }}
                placeholder="Chennai"
                required
              />
              <TextInput
                className={styles.field}
                label="Country"
                name="country"
                // value={title}
                type="text"
                // onChange={(e) => {
                //   titleFunction(e);
                // }}
                placeholder="India"
                required
              />
              <TextInput
                className={styles.field}
                label="Phone"
                name="phone"
                // value={title}
                type="text"
                // onChange={(e) => {
                //   titleFunction(e);
                // }}
                placeholder="9876543210"
                required
              />
              <div className={styles.buttons}>
                <button
                  className={cn("button", styles.button, styles.leftbtn)}
                  onClick={() => {
                    // if (address) purchase();
                    // else setIsSelectWallet(true);
                    // setIsDeleverd(true)
                  }}
                >
                  Continue
                </button>
                <button
                  className={cn(
                    "button-stroke",
                    styles.button,
                    styles.rightbtn
                  )}
                  onClick={() => {
                    setDeleverd(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default Purchase;
